// Brand tokens — single source of truth for the Kessem mark.
// Colors and proportions used by Logo + LogoMark.

export const KESSEM_BRAND = {
  /** Cyan accent — sparkle, K diagonals, badge background. */
  accent: "#22D3EE",
  /** Wordmark / K vertical bar on a dark surface. */
  inkLight: "#FFFFFF",
  /** Wordmark / K vertical bar on a light surface. */
  inkDark: "#0A0A14",
  /** Brand background (deep blue-black). Used for OG / badge inverse. */
  bg: "#070710",
} as const;

/** Logo height presets (px) — matches Tailwind h-6 / h-8 / h-10. */
export const LOGO_SIZE: Record<"sm" | "md" | "lg", number> = {
  sm: 24,
  md: 32,
  lg: 40,
};
